import React, { useState } from 'react';
import bookCover from './../images/empty-book.svg';
import EditBook from './EditBook';
import searchIcon from './../images/search-line.svg';
import optionsIcon from './../images/adjust-line.svg';
// import langIcon from './../images/location-line.svg';
import TextInput from './TextInput';
import { useTranslation } from '../i18n';
import { propsToText, updateProtocol } from '../utils/functions';
import SelectInput from './SelectInput';
import BookSummary from './BookSummary';

const BookSearch = ({
  handleInputChange,
  handleSearch,
  handleSetHistory,
  // lang,
  // handleLangChange,
  options,
  handleOptionsChange,
  openModal,
  input,
  loading,
  saving,
  user,
  showNotification,
  fetchBooks,
  setBookInfo,
  foundBooks,
  updateCurrentlyReading,
}) => {
  const onFormSubmit = (e) => {
    e.preventDefault();
    handleSearch(input);
    handleSetHistory(input, options, true);
  };

  const [isEditing, setIsEditing] = useState(false);
  function toggleEdit() {
    setIsEditing(!isEditing);
  }

  const { t } = useTranslation();

  const handleSave = (bookInfo) => {
    setBookInfo(bookInfo);
    openModal();
  };

  return (
    <div className="section">
      <div className="heading-wrapper">
        <h2>{t.findbook}</h2>
      </div>

      <form onSubmit={onFormSubmit} className="form">
        <TextInput
          type="text"
          icon={searchIcon}
          labelName={t.searchLabel}
          id="searchInput"
          onChangeFunction={handleInputChange}
          value={input}
          required={true}
          clear={true}
          inputmode="search"
        />

        <SelectInput
          labelName={t.searchoptions}
          id="selectLanguage"
          onChangeFunction={handleOptionsChange}
          value={options}
          icon={optionsIcon}
          options={[
            { value: '', label: t.everything },
            { value: 'intitle:', label: t.title },
            { value: 'inauthor:', label: t.author },
            { value: 'subject:', label: t.subject },
            { value: 'publisher:', label: t.publisher },
            { value: 'isbn:', label: t.isbn },
          ]}
        />

        {/* <SelectInput
          labelName={t.preferedlanguage}
          id="selectLanguage"
          onChangeFunction={handleLangChange}
          value={lang}
          icon={langIcon}
          options={[
            { value: '', label: t.any },
            { value: 'en', label: t.english },
            { value: 'sv', label: t.swedish },
            { value: 'es', label: 'Spanish' },
            { value: 'fr', label: 'French' },
            { value: 'ar', label: 'Arabic' },
          ]}
        /> */}

        <div className="btn-group">
          <button
            type="submit"
            className="btn btn-primary w-100"
            onClick={() => (
              handleSearch(input), handleSetHistory(input, options, true)
            )}
            disabled={loading}
          >
            {loading ? t.searching : t.search}
          </button>
        </div>
        <button
          type="button"
          className="btn btn-borderless w-100"
          onClick={() => toggleEdit()}
          disabled={loading}
        >
          {t.addManually}
        </button>
      </form>

      {foundBooks && (
        <div
          id="search-results"
          className={`${foundBooks.length > 1 ? 'card-wrapper-offset' : 'card-wrapper'}`}
        >
          {foundBooks.map((bookInfo, index) => (
            <div key={bookInfo.id + `_${index}`} className="card">
              <div className="card-medium">
                <img
                  src={
                    bookInfo.volumeInfo.imageLinks?.smallThumbnail
                      ? updateProtocol(
                          bookInfo.volumeInfo.imageLinks.smallThumbnail,
                        )
                      : bookCover
                  }
                  alt={bookInfo.volumeInfo.title}
                  height={120}
                  width={80}
                  className="card-medium-image"
                  loading="lazy"
                />
                <div className="book-info">
                  <div className="book-header">
                    <h2 className="fs-l">{bookInfo.volumeInfo.title}</h2>
                    {bookInfo.volumeInfo.authors && (
                      <span className="fs-m pt-85">
                        {propsToText(bookInfo.volumeInfo.authors, 1) || 'N/A'}
                      </span>
                    )}
                  </div>
                  <div className="book-details">
                    <span className="fs-xs pt-65">
                      {t.pages}:{' '}
                      {bookInfo.volumeInfo.pageCount?.toLocaleString() ||
                        'unknown'}
                    </span>
                    {bookInfo.volumeInfo.publishedDate && (
                      <span className="fs-xs pt-65">
                        {t.published}: {bookInfo.volumeInfo.publishedDate}
                      </span>
                    )}
                    {bookInfo.volumeInfo.publisher && (
                      <span className="fs-xs pt-65">
                        {t.publisher}: {bookInfo.volumeInfo.publisher}
                      </span>
                    )}
                    {bookInfo.volumeInfo.industryIdentifiers && (
                      <span className="fs-xs pt-65">
                        {bookInfo.volumeInfo.industryIdentifiers[0].type
                          .toLowerCase()
                          .includes('isbn')
                          ? t.isbn
                          : t.other}
                        :{' '}
                        {propsToText(
                          bookInfo.volumeInfo.industryIdentifiers[0].identifier,
                          1,
                        ) || 'unknown'}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="separator"></div>
              <div className="btn-group-right">
                <button
                  onClick={() => handleSave(bookInfo)}
                  disabled={saving}
                  className="btn btn-sm btn-primary"
                >
                  {t.savebook}
                </button>
                {bookInfo.volumeInfo.description && (
                  <BookSummary
                    bookInfo={bookInfo}
                    buttonClass={'btn btn-sm btn-secondary'}
                    saving={saving}
                    handleSave={handleSave}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      )}
      {isEditing && (
        <EditBook
          backText={t.backtosearch}
          buttonText={t.savebook}
          toggleEdit={toggleEdit}
          input={input}
          options={options}
          fetchBooks={fetchBooks}
          required={true}
          user={user}
          showNotification={showNotification}
          updateCurrentlyReading={updateCurrentlyReading}
        />
      )}
    </div>
  );
};

export default BookSearch;
